import React, { useState, useRef, useEffect } from "react";

const FDA_DOC_TYPES = ["Label", "Letter", "Review", "Medication Guide"];

const DownloadDropdown = ({ 
    downloadType, 
    onTypeChange, 
    onDownload, 
    disabled, 
    isLoading,
    // FDA mode props
    fdaMode,
    downloadTypes,
    onTypesChange,
    // CT mode props
    ctMode,
    // EMA mode props
    emaMode,
}) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleEvents = (e) => {
            if (e.key === "Escape") {
                setOpen(false);
            }
            if (e.type === "pointerdown" && ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("keydown", handleEvents);
        document.addEventListener("pointerdown", handleEvents);

        return () => {
            document.removeEventListener("keydown", handleEvents);
            document.removeEventListener("pointerdown", handleEvents);
        };
    }, []);

    const typeLabel = fdaMode
        ? (downloadTypes?.length > 0 ? `${downloadTypes.length} selected` : "All Types")
        : ctMode
        ? (downloadType === "full_text" ? "Documents" : "CSV")
        : emaMode
        ? (downloadType === "full_text" ? "Documents" : "CSV")
        : (downloadType === "abstract" ? "Abstracts" : "Full-Text");

    return (
        <div
            className="ev-message-card3 ev-radius-xsmall p-1 position-relative d-inline-flex gap-2"
            ref={ref}
        >
            <button 
                className="ev-btn-blue-fill-round ev-btn-xsmall d-flex align-items-center gap-2 pe-3"
                onClick={onDownload}
                disabled={disabled}
            >
                {isLoading ? (
                    <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Downloading...
                    </>
                ) : (
                    <>
                        <i className="bi bi-download" />
                        Download
                    </>
                )}
            </button>

            <button
                className="ev-btn-white-fill-round ev-btn-xsmall d-flex align-items-center gap-3 ev-btn-border-square ev-med-p-blue"
                onClick={() => setOpen(prev => !prev)}
                aria-haspopup="true"
                aria-expanded={open}
                disabled={isLoading}
            >
                {typeLabel}
                <i className={`bi ${open ? "bi-chevron-up" : "bi-chevron-down"}`} />
            </button>

            {open && (
                <div
                    className="ev-card-8 ev-radius-xsmall position-absolute top-100 end-0 mt-2 p-2 z-3 w-100"
                    role="menu"
                >
                    {fdaMode ? (
                        FDA_DOC_TYPES.map((type) => (
                            <div
                                key={type}
                                className="d-flex align-items-center gap-1 ps-1 cursor-pointer ev-btn-small"
                                onClick={() => onTypesChange(
                                    downloadTypes.includes(type)
                                        ? downloadTypes.filter((t) => t !== type)
                                        : [...downloadTypes, type]
                                )}
                            >
                                <input
                                    type="checkbox"
                                    checked={downloadTypes.includes(type)}
                                    onChange={() => {}}
                                />
                                <span className="ev-small-p-dark">{type}</span>
                            </div>
                        ))
                    ) : (
                        <>
                            <button
                                className={`w-100 text-start ev-radius-xsmall ev-btn-small mb-1 ${
                                    downloadType === "abstract" 
                                        ? "ev-btn-blue-fill-round" 
                                        : "ev-btn-light-fill ev-reg-p-blue"
                                }`}
                                role="menuitem"
                                onClick={() => {
                                    onTypeChange("abstract");
                                    setOpen(false);
                                }}
                            >
                                {ctMode || emaMode ? "CSV" : "Abstracts (CSV)"}
                            </button>
                            <button
                                className={`w-100 text-start ev-radius-xsmall ev-btn-small ${
                                    downloadType === "full_text" 
                                        ? "ev-btn-blue-fill-round" 
                                        : "ev-btn-light-fill ev-reg-p-blue"
                                }`}
                                role="menuitem"
                                onClick={() => {
                                    onTypeChange("full_text");
                                    setOpen(false);
                                }}
                            >
                                {ctMode || emaMode ? "Documents (ZIP)" : "Full-Text (ZIP)"}
                            </button>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default DownloadDropdown;